import m from 'mithril'

export default {
  view: vnode => {
    const fangerfolk = require('./fangerfolk.png')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-14-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text  mod-h3">Husk grønlandsoverenskomsten mellem Danmark og USA! </h3>
          <p className="log-book-text">Det er aftalen fra 1951, hvor USA får tilladelse til at være i Grønland i bestemte militære områder. I artikel 5 i aftalen står der, at der skal “tages videst mulige Hensyn, forenelig med militær Nødvendighed, til Grønlands indfødte Befolknings Velfærd, Sundhed og økonomiske Erhvervsinteresser”  </p>

          <figure className="log-book-figure">
            <img src={fangerfolk} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Thuleboernes slædeveje løber forbi amerikanernes radarer, som skal opfange, om der er fjendtlige missiler på vej. 
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
